import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useAppDispatch } from 'state'
import { Form, Input, Button, Row, Col } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useUsers } from 'state/users/hooks'
import { fetchUsersFailed, verifyTwoFactorCode } from 'state/users'
import { verifyCode, resendCode, resendAlternateCode, fetchLoginFailed } from 'state/login-progress'
import { useLoginProgress } from 'state/login-progress/hooks'
import history from 'routerHistory'

const CodeForm = () => {
  const { isAuthenticated, isLoading, hasError } = useUsers()
  const dispatch = useAppDispatch()
  const { username, loginProgress } = useLoginProgress()

  const [formLoading, setFormLoading] = useState(false)

  const onCodeFinish = useCallback(
    (values) => {
      setFormLoading(true)

      const { verification, username, loginProgress } = values

      if (loginProgress === 'resetPassword') {
        // console.log('password')
        dispatch(verifyCode(verification.trim(), username.trim()))
      } else {
        //  console.log('not password')
        dispatch(verifyTwoFactorCode(verification.trim(), username.trim()))
      }
    },
    [dispatch],
  )

  /* Code resend */
  const onCodeResend = useCallback(() => {
    dispatch(resendCode(username))
  }, [dispatch, username])

  const onCodeAlternate = useCallback(() => {
    console.log(username)
    dispatch(resendAlternateCode(username))
  }, [dispatch, username])

  /* Back to login clear state */
  const onBacktoLogin = useCallback(() => {
    localStorage.clear()
    sessionStorage.clear()
    dispatch(fetchUsersFailed())
    dispatch(fetchLoginFailed())
  }, [dispatch])

  /* Check state auth if so redirect them */

  useEffect(() => {
    let isCancelled = false
    if (!isLoading) {
      if (isAuthenticated) {
        history.push('/')
      }
    }
    return () => {
      isCancelled = true
    }
  }, [isAuthenticated, isLoading])

  useEffect(() => {
    if (hasError) {
      setFormLoading(false)
    }
  }, [hasError])

  return (
    <Form
      name="login"
      onFinish={onCodeFinish}
      fields={[
        {
          name: ['username'],
          value: username,
        },
        {
          name: ['loginProgress'],
          value: loginProgress,
        },
      ]}
      size="large"
    >
      <Form.Item
        name="verification"
        rules={[
          {
            required: true,
            message: 'Please input your verification code!',
          },
        ]}
      >
        <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Verification Code" />
      </Form.Item>
      <Form.Item hidden name="username">
        <Input type="hidden" />
      </Form.Item>
      <Form.Item hidden name="loginProgress">
        <Input type="hidden" />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: '100%', marginBottom: '0px', background: '#254874' }}
          loading={formLoading}
        >
          Submit Your Code
        </Button>
        <Button
          type="link"
          style={{ fontSize: '12px', marginTop: '0px', color: '#254874', textAlign: 'right', width: '50%' }}
          onClick={() => onCodeResend()}
        >
          Resend Code
        </Button>
        <Button
          type="link"
          style={{ fontSize: '12px', marginTop: '0px', color: '#254874', textAlign: 'left', width: '50%' }}
          onClick={() => onBacktoLogin()}
        >
          Back to Login
        </Button>

        <Button
          type="link"
          style={{
            fontSize: '12px',
            margin: '0px',
            color: '#254874',
            textAlign: 'center',
            width: '90%',
            whiteSpace: 'normal',
            height: 'auto',
          }}
          onClick={() => onCodeAlternate()}
        >
          I dont have access to my Email. Send via SMS.
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CodeForm
